import { createAction } from 'typesafe-actions';
import { InstagramUserInfo, InstagramPost } from '@lib/domain/instagram';
import {
    InstagramOverviewOrder,
    InstagramCompleteOrder,
} from '@lib/state/Instagram/types';
import { createActionTypePrefixFormat } from '../common';

const typePrefixFormat = createActionTypePrefixFormat('Instagram');

/* ------------- action creators ------------- */
export const setInstagramUser = createAction(
    typePrefixFormat('SET_INSTAGRAM_USER'),
    (user: InstagramUserInfo) => ({
        user,
    }),
)();

export const setInstagramPosts = createAction(
    typePrefixFormat('SET_INSTAGRAM_POSTS'),
    (posts: InstagramPost[]) => ({
        posts,
    }),
)();

export const setInstagramOverviewOrder = createAction(
    typePrefixFormat('SET_INSTAGRAM_OVERVIEW_ORDER'),
    (order: InstagramOverviewOrder) => ({
        order,
    }),
)();

export const setInstagramCompleteOrder = createAction(
    typePrefixFormat('SET_INSTAGRAM_COMPLETE_ORDER'),
    (order: InstagramCompleteOrder) => ({
        order,
    }),
)();

export const resetInstagramData = createAction(
    typePrefixFormat('RESET_INSTAGRAM_DATA'),
    () => null,
)();

export type InstagramActions = ReturnType<
    | typeof setInstagramUser
    | typeof setInstagramPosts
    | typeof setInstagramOverviewOrder
    | typeof setInstagramCompleteOrder
    | typeof resetInstagramData
>;
